let sectionManager = require('./sections');

function escapeHtml(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

module.exports = {

    tabs: [],
    activeIndex: null,
    fieldPool: [],

    registerEvents() {
        let _this = this;
        let $body = $('body');

        $body.on('click', '.edit-column-tabs', function (e) {
            e.preventDefault();
            _this.openModal();
        });

        $body.on('click', '.add-column-tab-view', function (e) {
            e.preventDefault();
            _this.tabs.push({
                key: 'view_' + Date.now() + '_' + _this.tabs.length,
                name: translation.new_view,
                fields: []
            });
            _this.activeIndex = _this.tabs.length - 1;
            _this.renderSidebar();
            _this.renderDetail();
        });

        $body.on('click', '.column-tab-view-row', function (e) {
            if ($(e.target).hasClass('rename-view-btn') || $(e.target).hasClass('delete-view-btn')) {
                return;
            }
            _this.activeIndex = parseInt($(this).data('index'));
            _this.renderSidebar();
            _this.renderDetail();
        });

        $body.on('click', '.rename-view-btn', function (e) {
            e.stopPropagation();
            let index = parseInt($(this).data('index'));
            _this.activeIndex = index;
            _this.renderSidebar();
            _this.renderDetail();
            $('.column-tabs-view-name-input').focus().select();
        });

        $body.on('click', '.delete-view-btn', function (e) {
            e.stopPropagation();
            let index = parseInt($(this).data('index'));

            if (!confirm(translation.confirm_delete_view)) {
                return;
            }

            _this.tabs.splice(index, 1);

            if (_this.tabs.length === 0) {
                _this.activeIndex = null;
            } else if (_this.activeIndex >= _this.tabs.length) {
                _this.activeIndex = _this.tabs.length - 1;
            } else if (_this.activeIndex > index) {
                _this.activeIndex -= 1;
            }

            _this.renderSidebar();
            _this.renderDetail();
        });

        $body.on('keyup', '.column-tabs-view-name-input', function (e) {
            if (_this.activeIndex === null) {
                return;
            }
            _this.tabs[_this.activeIndex].name = $(this).val();
            _this.renderSidebar();
        });

        $body.on('change', '.toggle-field-visibility', function (e) {
            if (_this.activeIndex === null) {
                return;
            }
            let fieldId = parseInt($(this).data('id'));
            let tab = _this.tabs[_this.activeIndex];
            let checked = $(this).is(':checked');

            if (checked) {
                if (tab.fields.indexOf(fieldId) === -1) {
                    tab.fields.push(fieldId);
                }
                _this.promoteFieldToVisible(fieldId);
            } else {
                tab.fields = tab.fields.filter(id => id !== fieldId);
            }

            _this.renderDetail();
        });

        $body.on('click', '#save-column-tabs', function (e) {
            let $activeSection = $('body').find('.activeSection');
            $activeSection
                .attr('data-column-tabs', JSON.stringify(_this.tabs))
                .data('column-tabs', _this.tabs);
            $('#column-tabs-model').modal('hide');
        });
    },

    // Reads the visible list's current DOM order back into the active tab's
    // field order after a drag-and-drop reorder.
    reorderVisibleFields() {
        if (this.activeIndex === null) {
            return;
        }

        let tab = this.tabs[this.activeIndex];

        tab.fields = $('.column-tabs-visible-list > .column-tab-field-row').map(function () {
            return parseInt($(this).data('id'));
        }).get();
    },

    getFieldPool() {
        let pool = [];
        $('.visible-fields > p, .hidden-fields > p').each(function (i, item) {
            pool.push({
                id: parseInt($(item).data('id')),
                label: $(item).text()
            });
        });
        return pool;
    },

    // Assigning a field to a view implies it should actually render as a column
    // at all, which requires it to be part of the section's visible_columns.
    // Move it from the customizer's hidden-fields list to visible-fields the
    // same way a manual drag there would, using the existing setColumnAttributes()
    // so the change rides along in the normal Save Table flow.
    promoteFieldToVisible(fieldId) {
        let $field = $(`.hidden-fields > p[data-id="${fieldId}"]`);

        if ($field.length) {
            $field.appendTo('.visible-fields');
            sectionManager.setColumnAttributes();
        }
    },

    openModal() {
        let $activeSection = $('body').find('.activeSection');
        let existing = $activeSection.attr('data-column-tabs');

        try {
            this.tabs = existing ? JSON.parse(existing) : [];
        } catch (err) {
            this.tabs = [];
        }

        this.fieldPool = this.getFieldPool();
        this.activeIndex = this.tabs.length ? 0 : null;

        this.renderSidebar();
        this.renderDetail();

        $('#column-tabs-model').modal('show');
    },

    renderSidebar() {
        let _this = this;
        let html = '';

        this.tabs.forEach(function (tab, index) {
            html += `<div class="column-tab-view-row p-2 ${index === _this.activeIndex ? 'active' : ''}" data-index="${index}" data-key="${tab.key}" style="cursor:pointer; ${index === _this.activeIndex ? 'background-color: rgba(0,0,0,.05);' : ''}">
                        <i class="fas fa-arrows-alt drag-view-handle mr-2" style="cursor:grab;"></i>
                        <span class="view-name">${escapeHtml(tab.name)}</span>
                        <span class="view-actions float-right">
                            <i class="fas fa-pencil-alt rename-view-btn mr-2" data-index="${index}"></i>
                            <i class="fas fa-trash delete-view-btn" data-index="${index}"></i>
                        </span>
                    </div>`;
        });

        $('.column-tabs-views-list').html(html).sortable({
            items: '.column-tab-view-row',
            handle: '.drag-view-handle',
            cursor: 'grabbing',
            update: () => _this.reorderTabs()
        }).disableSelection();
    },

    // Reads the sidebar's current DOM order back into this.tabs after a
    // drag-and-drop reorder, keeping activeIndex pointed at the same tab.
    reorderTabs() {
        let activeKey = this.activeIndex !== null && this.tabs[this.activeIndex]
            ? this.tabs[this.activeIndex].key
            : null;

        let keyOrder = $('.column-tabs-views-list > .column-tab-view-row').map(function () {
            return $(this).data('key');
        }).get();

        this.tabs = keyOrder.map(key => this.tabs.find(tab => tab.key === key));

        if (activeKey !== null) {
            this.activeIndex = this.tabs.findIndex(tab => tab.key === activeKey);
        }

        this.renderSidebar();
    },

    renderDetail() {
        if (this.activeIndex === null || !this.tabs[this.activeIndex]) {
            $('.column-tabs-detail').html(`<div class="p-3 text-muted">${translation.add_view}</div>`);
            return;
        }

        let tab = this.tabs[this.activeIndex];
        let visibleIds = tab.fields || [];
        let pool = this.fieldPool;

        let visibleFields = visibleIds
            .map(id => pool.find(f => f.id === id))
            .filter(Boolean);

        let hiddenFields = pool.filter(f => visibleIds.indexOf(f.id) === -1);

        let visibleRows = visibleFields.map(f => `
            <div class="column-tab-field-row d-flex align-items-center justify-content-between p-2 border-bottom" data-id="${f.id}">
                <span>
                    <i class="fas fa-arrows-alt drag-field-handle mr-2" style="cursor:grab;"></i>
                    ${escapeHtml(f.label)}
                </span>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input toggle-field-visibility" id="tab-field-${f.id}" data-id="${f.id}" checked>
                    <label class="custom-control-label" for="tab-field-${f.id}"></label>
                </div>
            </div>`).join('');

        let hiddenRows = hiddenFields.map(f => `
            <div class="column-tab-field-row d-flex align-items-center justify-content-between p-2 border-bottom text-muted">
                <span>${escapeHtml(f.label)}</span>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input toggle-field-visibility" id="tab-field-${f.id}" data-id="${f.id}">
                    <label class="custom-control-label" for="tab-field-${f.id}"></label>
                </div>
            </div>`).join('');

        let fieldsVisibleText = translation.fields_visible_of
            .replace('x', visibleFields.length)
            .replace('x', pool.length);

        let html = `
            <div class="p-3">
                <input type="text" class="form-control column-tabs-view-name-input mb-1" value="${escapeHtml(tab.name)}">
                <div class="text-muted mb-2">${fieldsVisibleText}</div>
                <div class="text-uppercase text-muted small mt-2">${translation.visible_fields}</div>
                <div class="column-tabs-visible-list">${visibleRows}</div>
                <div class="text-uppercase text-muted small mt-3">${translation.hidden_fields}</div>
                <div class="column-tabs-hidden-list">${hiddenRows}</div>
            </div>`;

        $('.column-tabs-detail').html(html);

        $('.column-tabs-visible-list').sortable({
            items: '.column-tab-field-row',
            handle: '.drag-field-handle',
            cursor: 'grabbing',
            update: () => this.reorderVisibleFields()
        }).disableSelection();
    }
};